export default __webpack_public_path__ + "static/media/bullseye.e56efa2b.svg";